import React from 'react';
import { IconButton } from '@mui/material';
import { FileCopy } from '@mui/icons-material';

interface CloneIconButtonProps {
  style?: React.CSSProperties;
  onClick: () => void;
}

const CloneIconButton: React.FC<CloneIconButtonProps> = ({ onClick, ...props }) => {
  return (
    <IconButton aria-label="clone" onClick={onClick} {...props}>
      <FileCopy fontSize="small" />
    </IconButton>
  );
};

export default CloneIconButton;
